import { useParams } from "react-router-dom"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { Button } from "../components/Button"
import "./ProductDetailPage.css"
import Tab1 from "../img/products/1.png";
import Tab2 from "../img/products/2.png";
import Tab3 from "../img/products/3.png";
import Tab4 from "../img/products/4.png";
import Tab5 from "../img/products/5.png";
import Tab6 from "../img/products/6.png";
import Tab7 from "../img/products/7.png";
import Tab8 from "../img/products/8.png";
import Tab9 from "../img/products/9.png";
import Tab10 from "../img/products/10.png";
import Tab11 from "../img/products/11.png";
import Tab12 from "../img/products/12.png";
import Tab13 from "../img/products/13.png";

export default function ProductDetailPage() {
  const { id } = useParams()

  const products = {
    1: {
      name: "GERDHEAL DSR",
      category: "Gastroenterology",
      description: "Rabeprazole Sodium 20mg & Domperidone (SR) 30 mg Caspules",
      activeIngredient: "Rabeprazole Sodium - 20 mg",
      benefits: [
        "Reduces stomach acid production",
        "Treats GERD effectively",
        "Prevents ulcers",
        "Long-lasting relief",
      ],
      dosage: "1 tablet once daily before breakfast",
      image: Tab1,
    },
    2: {
      name: "Natodrive-MNT",
      category: "Lorem Ipsum",
      description: "Pregabalin 75mg, Mecobalamin 1500 mcg. & Nortriptyline 10mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab2,
    },
    3: {
      name: "Natodrive-SP",
      category: "Lorem Ipsum",
      description: "Aceclofenac 100mg + Paracetamol 325mg & Serratiopeptidase 15mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab3,
    },
    
    4: {
        name: "Semecal-P",
     category: "Lorem Ipsum",
      description: "Calcium, Phosphorus, Magnesium, Zinc, Vitamin B12 & Vitamin D3 Suspension",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab13,
    },
    5: {
      name: "Noblefer",
     category: "Lorem Ipsum",
      description: "Ferric Pyrophosphate 30mg + Folic Acid 250mcg + Glycine 10mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab5,
    },
    6: {
      name: "Zymoshine Syrup",
     category: "Lorem Ipsum",
      description: "Fungal Diastase with Pepsin",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab6,
    },
    7: {
      name: "Etosooth-MR ",
     category: "Lorem Ipsum",
      description: "Etoricoxib 60mg + Thiocolchicoside 4mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab7,
    },
    8: {
      name: "Semecal-D",
     category: "Lorem Ipsum",
      description: "Calcium, Magnesium, Zinc & Vitamin D3",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab8,
    },
    9: {
     name: "Elosooth-90",
     category: "Lorem Ipsum",
      description: "Etoricoxib 90mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab12,
    },
    10: {
      name: "Gerdheal20",
      category: "Lorem Ipsum",
      description: "Rabeprazole Sodium 20mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab10,
    },
    11: {
      name: "Qroshine Syrup",
      category: "Lorem Ipsum",
      description: "Multivitamin, Multimineral With Lycopene & Amino Acid Syrup",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab11,
    },
    12: {
      
       name: "Qroshine-TM",
     category: "Lorem Ipsum",
      description: "Co Enzyme Q10 100mg + EPA 90mg + DPA 60mg + Lycopene 4000mcg + L-Arginine 250mg + L-Glutaione 10mg + L-Carnitine 250mg Alpha Lipoic Acid 100mg + Vitamin B6 1mg + Vitamin E 5mg +Vitamin D3 400 I.U. + Zinc 12mg + Manganese 5mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab9,
    },
    13: {
   
      name: "Semecal Total",
      category: "Lorem Ipsum",
      description: "Calcium Carbonate 1250 mg (Elemental Calcium 500mg) + Vit. D3 2000 IU + Methylcobalamin 1500 mcg. + L-Methylfolate Calcium 1mg + Pyridoxal-5-Phosphate 20mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab4,
    },
  }

  const product = products[id]

  if (!product) {
    return (
      <main className="product-detail-main">
        <Header />
        <div className="product-detail-not-found">
          <h1 className="text-4xl font-bold text-foreground">Product Not Found</h1>
        </div>
        <Footer />
      </main>
    )
  }

  return (
    <main className="product-detail-main">
      <Header />

      <div className="product-detail-container">
        <div className="product-detail-grid">
          <div className="product-detail-image-wrapper">
            <img src={product.image || "/placeholder.svg"} alt={product.name} className="product-detail-image" />
          </div>

          <div className="product-detail-info">
            <div className="product-detail-header">
              {/* <div className="product-detail-category">
                {product.category}
              </div> */}
              <h1 className="product-detail-title">{product.name}</h1>
              <p className="product-detail-description">{product.description}</p>
            </div>

            <div className="product-detail-sections">
              {/* <div>
                <h3 className="product-detail-section-title">Active Ingredient</h3>
                <p className="product-detail-text">{product.activeIngredient}</p>
              </div> */}
{/* 
              <div>
                <h3 className="product-detail-section-title">Key Benefits</h3>
                <ul className="product-detail-benefits">
                  {product.benefits.map((benefit, i) => (
                    <li key={i} className="benefit-item">
                      <span className="benefit-dot"></span>
                      <span className="benefit-text">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div> */}

              {/* <div>
                <h3 className="product-detail-section-title">Recommended Dosage</h3>
                <p className="product-detail-text">{product.dosage}</p>
              </div> */}

              <div className="product-detail-actions">
                <Button className="btn-request"><a href="/contact" className="btn-link">Request Information</a></Button>
                {/* <Button variant="outline" className="btn-brochure">
                  Download Brochure
                </Button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </main>
  )
}

